export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9857.44a501a8.jpg";